import apiService,{ HOST,showPdfNewTab } from "./BaseApi";
import Utils from '@/scripts/Utils';
// const ENDPOINT_PATH = "/consumption/generate-pdf";
import { showErrorSnackBar } from "@/utils/SnackBartHelper"

const downloadPdf = async (response) => {  
    if (response.status === 200 && response.data.signedUrl) showPdfNewTab(response.data.signedUrl)
    else showErrorSnackBar("Erro ao gerar proposta. Tente novamente!")
}

const RoiApi = {
    generateRoiPerformancePdf: async (pdfName, params) => {
        params = {...params, env: Utils.getEnv()}
        let response = await apiService.post('/roi/performance', params)
        await downloadPdf(response)
    },
    generateSalesRoiPdf: async (pdfName, params) => {
        params = {...params, env: Utils.getEnv()}
        try {
            let response = await apiService.post('/roi/sales', params)
            await downloadPdf(response)
            return true
        } catch (e) {
            return false
        }
    },
    generateFinancialFlowRoiPdf: async (pdfName, params) => {
        params = {...params, env: Utils.getEnv()}
        try {
            let response = await apiService.post('/roi/financial-flow', params)
            await downloadPdf(response)
            return true
        } catch (e) {
            return false
        }
    },
};

export default RoiApi;
